import React from 'react';

export const Button = React.forwardRef(
	(
		{
			children,
			variant = 'primary',
			size = 'medium',
			loading = false,
			disabled = false,
			onClick,
			type = 'button',
			className = '',
			style = {}
		},
		ref
	) => {
		const variantClass = `button-${variant}`;
		const sizeClass = size !== 'medium' ? `button-${size}` : '';
		const loadingClass = loading ? 'loading' : '';

		return (
			<button
				ref={ref}
				type={type}
				disabled={disabled || loading}
				onClick={onClick}
				className={`button-v2 ${variantClass} ${sizeClass} ${loadingClass} ${className}`}
				style={style}>
				{children}
			</button>
		);
	}
);

export const FormButtons = ({
	onCancel,
	onSubmit,
	submitLabel = 'Create',
	cancelLabel = 'Cancel',
	submitDisabled = false,
	loading = false,
	variant = 'footer',
	className = '',
	middleButton = null
}) => {
	const containerClass =
		variant === 'header'
			? `form-buttons-header-v2 ${className}`
			: `form-buttons-v2 ${className}`;

	return (
		<div className={containerClass}>
			<Button
				variant="secondary"
				onClick={onCancel}
				size={variant === 'header' ? 'large' : 'medium'}>
				{cancelLabel}
			</Button>
			{middleButton && (
				<Button
					variant="secondary"
					onClick={middleButton.onClick}
					disabled={middleButton.disabled}
					loading={middleButton.loading}
					size={variant === 'header' ? 'large' : 'medium'}>
					{middleButton.label}
				</Button>
			)}
			<Button
				variant="primary"
				type="submit"
				disabled={submitDisabled}
				loading={loading}
				onClick={onSubmit}
				size={variant === 'header' ? 'large' : 'medium'}>
				{submitLabel}
			</Button>
		</div>
	);
};
